<template>
<div class="CreateSpecificElementCompletionTypeMilestoneOverlayDiv">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc" :style="{'top': overlayTop + '%'}">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="close-text-font-style margin-right-1Perc margin-Top-1Perc margin-bottom-5Perc cursor-pointer " v-on:click="closeOverlay">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right close-image-zindex-1" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Group
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12 text-align-left">
                      <span class="font-weight-bold create-lesson-input-text-style">{{selectedGroupObj.GroupName}}</span>
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Milestone Type
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12 text-align-left">
                      <span class="font-weight-bold create-lesson-input-text-style">{{selectedMilestoneInfoObj.Title}}</span>
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Milestone Title
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" v-model="getMilestoneTitle" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Group Course(s)
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="selectedGroupCourseObj">
                        <option value=-1 disabled>Select</option>
                        <option v-for="groupCourseObj in getGroupCourseList" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj" v-if="groupCourseObj.GroupId === getCurrentSelectedGroupObj.GroupId">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <!-- For showing bottom border -->
              <div class="row vertical-align margin-bottom-2Perc" v-if="showCourseJourneyUI">
                <div class="col-md-1 col-lg-1 create-lesson-input-text-style">
                </div>
                <div class="col-md-10 col-lg-10 create-lesson-input-text-style bottom-border-grey">
                </div>
                <div class="col-md-1 col-lg-1 create-lesson-input-text-style">
                </div>
              </div>
              <!-- For showing bottom border -->
              <div class="row vertical-align margin-bottom-2Perc" v-if="showCourseJourneyUI">
                <div class="col-md-1 col-lg-1 create-lesson-input-text-style">
                   
                </div>
                <div class="col-md-10 col-lg-10 create-lesson-input-text-style font-size-19px">
                  Specify Elements to complete
                </div>
                <div class="col-md-1 col-lg-1 create-lesson-input-text-style">
                </div>
              </div>
              <div class="row margin-bottom-2Perc margin-left-15px margin-right-15px" :class="{'fix-height' : showCourseJourneyUI}" :style="{'max-height': windowHeight + 'px'}">
                <div class="col-md-1 col-lg-1">
                </div>
                 <div class="col-md-10 col-lg-10">
                   <milestone-lesson-list v-for="currLessonObj in getCourseJourneyList" :key="currLessonObj.ModuleId" :currLessonObj="currLessonObj" :courseJourneyList="getCourseJourneyList" v-if="!currLessonObj.IsBonusContent"></milestone-lesson-list>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="createMilestone">Create Milestone</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
 </div>
 </div>
</template>

<script>
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import MilestoneLessonList from '@/components/MilestoneLessonList'
import { groupCourseService } from '@/server-util/group-course-service'
import { milestoneService } from '@/server-util/milestone-service'
export default {
  props: ['selectedGroupObj', 'selectedMilestoneInfoObj'],
  created: function () {
    this.getAllGroupCourses()
    this.setDefaultValues()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      selectedMilestoneObj: -1,
      selectedGroupCourseObj: -1,
      courseJourneyList: [],
      showCourseJourneyUI: false,
      milestoneObj: {
        MilestoneInfoId: '',
        Title: '',
        GroupId: '',
        CourseMasterId: '',
        Data: {
          ElementIds: []
        }
      },
      windowHeight: 200,
      overlayTop: 20
    }
  },
  name: 'CreateSpecificElementCompletionTypeMilestoneOverlayDiv',
  methods: {
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    },
    getWidthAndHeightOfScreen: function () {
      if (window.innerWidth !== undefined && window.innerHeight !== undefined) {
        var w = window.innerWidth
        var h = window.innerHeight
      } else {
        w = document.documentElement.clientWidth
        h = document.documentElement.clientHeight
      }
      console.log('Page size: width=' + w + ', height=' + h)
      if ((h - 500) > 200) {
        this.windowHeight = h - 500
      }
    },
    setDefaultValues: function () {
      this.milestoneObj.MilestoneInfoId = this.selectedMilestoneInfoObj.MilestoneInfoId
      this.milestoneObj.GroupId = this.getCurrentSelectedGroupObj.GroupId
      this.$store.state.elementIdsToComplete = []
      this.getWidthAndHeightOfScreen()
    },
    getCourseTitle: function (courseObj) {
      var courseName = courseObj.CourseTitle
      var courseSubTitle = courseObj.SubTitle
      if (courseSubTitle !== 'null' && courseSubTitle !== '' && courseSubTitle !== null && courseSubTitle !== undefined) {
        courseName += ' [' + courseSubTitle + ']'
      }
      return courseName
    },
    closeOverlay: function () {
      var obj = {
        hasMilestoneCreatedOrUpdated: false,
        closeOverlay: false,
        type: 'create'
      }
      this.$emit('closeOverlay', obj)
    },
    getAssociatedCourseJourney: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== '' && storeObj.state.access_token !== null) {
        this.$store.state.isLoading = true
        groupCourseService.getCourseJourney(storeObj.state.access_token, this.selectedGroupCourseObj.CourseMasterId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store given course journey list into local variable
              this.courseJourneyList = responseObj.data
              // AK: Hide Spinner if its showing to user
              this.$store.state.isLoading = false
              if (this.courseJourneyList.length > 0) {
                this.showCourseJourneyUI = true
                this.overlayTop = 5
              } else {
                this.showCourseJourneyUI = false
                this.showAlertDialog = true
                this.overlayTop = 20
                this.errorMsg = 'No elements were found in \'' + this.selectedGroupCourseObj.GroupName + ' :: ' + this.selectedGroupCourseObj.CourseTitle + ' ' + (this.selectedGroupCourseObj.CourseSubTitle !== null && this.selectedGroupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + this.selectedGroupCourseObj.CourseSubTitle + ']' : '') + '\''
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if its showing to user
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            // AK: Hide Spinner if its showing to user
            this.$store.state.isLoading = false
          })
      } else {
        console.log('ACCESS TOKEN IS NOT FOUND HENCE DECLINE LOADING COURSE JOURNEY OPERATION')
      }
    },
    createMilestone () {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var storeObj = this.$store
        if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== '' && storeObj.state.access_token !== null) {
          this.$store.state.isLoading = true
          var _this = this
          this.milestoneObj.CourseMasterId = this.selectedGroupCourseObj.CourseMasterId
          this.milestoneObj.Data.ElementIds = this.getElementIdsToComplete
          this.milestoneObj.Data = JSON.stringify(this.milestoneObj.Data)
          milestoneService
            .addMilestone(
              storeObj.state.access_token,
              this.milestoneObj
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                _this.$store.state.isLoading = false
                // AK: Close current create milestone overlay
                var obj = {
                  hasMilestoneCreatedOrUpdated: true,
                  closeOverlay: false,
                  type: 'create'
                }
                _this.$emit('closeOverlay', obj)
              } else {
                _this.$store.state.isLoading = false
                _this.showAlertDialog = true
                _this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              if (errorObj.response === undefined) {
                _this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                _this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log('FOUND EMPTY ACCESS TOKEN HENCE DECLINED CREATING NEW MISSION OPERATION.')
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.getMilestoneTitle.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please enter a milestone title.'
        return false
      } else if (this.selectedGroupCourseObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group course.'
        return false
      } else if (this.getElementIdsToComplete.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one element.'
        return false
      }
      return true
    }
  },
  components: {
    'alert-box': AlertBox,
    'milestone-lesson-list': MilestoneLessonList
  },
  computed: {
    getElementIdsToComplete: {
      get: function () {
        return this.$store.state.elementIdsToComplete
      }
    },
    getCourseJourneyList: {
      get: function () {
        return this.courseJourneyList
      }
    },
    getGroupCourseList: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    getCurrentSelectedGroupObj: {
      get: function () {
        return this.selectedGroupObj
      }
    },
    getMilestoneList: {
      get: function () {
        return this.$store.state.milestoneList
      }
    },
    getSelectedMilestoneObj: {
      get: function () {
        return this.selectedMilestoneObj
      },
      set: function (newValue) {
        this.selectedMilestoneObj = newValue
      }
    },
    getMilestoneTitle: {
      get: function () {
        return this.milestoneObj.Title
      },
      set: function (newValue) {
        this.milestoneObj.Title = newValue
      }
    }
  },
  watch: {
    selectedGroupCourseObj: function (newValue, oldValue) {
      if (newValue !== -1) {
        this.$store.state.elementIdsToComplete = []
        this.courseJourneyList = []
        this.showCourseJourneyUI = true
        this.overlayTop = 20
        this.getAssociatedCourseJourney()
      }
    }
  }
}
</script>

<style scoped>
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left !important;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;
}
.bottom-border-grey {
  border-bottom:1px solid #ddd;
}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

.overflow-x-hidden{
  overflow-x: hidden !important;
}
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 20%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-right-15px {
  margin-right: 15px;
}
.margin-left-15px {
  margin-left: 15px;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
  border: 1px solid red;
}
.font-weight-bold {
  font-weight: 700;
}
.opacity {
  opacity: 0.75;
}
.font-size-12px {
  font-size: 12px;
}
.fix-height {
  overflow: auto;
}
.font-size-19px {
  font-size: 19px;
}
</style>


// WEBPACK FOOTER //
// src/components/CreateSpecificElementCompletionTypeMilestoneOverlay.vue